import * as moment from 'moment';
import { CreatedBy } from '../../../shared/enums/created-by.enum';
import { PaymentMethod } from '../../../shared/enums/payment-method.enum';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Invoice } from '../../../shared/models/invoice.model';
import { CustomerType } from '../../customers/enums/customer-type.enum';
import { CustomerInfo } from '../../customers/models/customer-info.model';
import { Store } from '../../store/models/store.model';
import { ReservationConfigType } from '../enums/reservation-config-type.enum';
import { ReservationStatus } from '../enums/reservation-status.enum';
import { ReservationConfig } from './reservation-config.model';

export class Reservation {
  id: number;
  store: Store;
  quota: number;
  sectorId: number;
  sectorName: string;
  seats: number;
  overbooking: boolean;
  description: string;
  user: CustomerInfo; // cliente consumidor que fez a própria reserva
  reservationDate: Date | string; // "2021-02-15"
  reservationTime: string;
  config: ReservationConfig;
  status: ReservationStatus;
  present: boolean;
  reservationNumber: number;
  noteReject: string;
  employer: Employee;
  uniqueCode: number;
  customerInfo: CustomerInfo; // estabelecimento que fez a própria reserva
  createdBy: CreatedBy;
  configType: ReservationConfigType;
  invoice?: Invoice;

  // Usado durante edição
  oldReservationDate: Date | string;
  oldReservationTime: string;
  oldQuota: number;
  oldSeats: number;

  // auxilia na tela
  customer: CustomerInfo;
  reservationFee: number;
  customReservationFee?: number;
  paymentRequired: boolean;
  paymentType: PaymentMethod;
  reservationQtdeInfo: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (typeof this.reservationDate === 'string') {
      this.reservationDate = moment(this.reservationDate, 'YYYY-MM-DD').toDate();
    }
    if (!this.description) {
      this.description = '';
    }
    if (!this.configType) {
      this.configType = ReservationConfigType.DEFAULT;
    }

    // Para facilitar as visualizações na tela, seto no objeto auxiliar customer as infos do usuário
    if (this.user) {
      this.customer = new CustomerInfo(this.user);
    } else if (this.customerInfo) {
      this.customer = new CustomerInfo(this.customerInfo);
    } else if (this.id) {
      // Teoricamente não pode existir uma reserva sem usuário
      this.customer = new CustomerInfo({
        name: '(Cliente não encontrado)',
        phone: '',
      });
    }

    if (this.customer && !this.customer.type) {
      this.customer.type = this.id && this.user ? CustomerType.USER : CustomerType.PRE_USER;
    }

    if (this.sectorName && this.sectorId && this.seats) {
      this.reservationQtdeInfo = `${this.sectorName} - Mesa de ${this.seats} lugares`;
      // TODO: após revisar bug que não está atualizando quota, voltar a mostrar
      // if (this.quota != this.seats) {
      // 	this.reservationQtdeInfo += ` (${this.quota} pessoas)`;
      // }
    } else {
      this.reservationQtdeInfo = `${this.quota} pessoas`;
    }
  }

  toJsonCreate(paymentAccountStatusError: any): any {
    let paymentMethod: string = null;
    if (!paymentAccountStatusError && this.reservationFee) {
      paymentMethod = PaymentMethod.PIX['code'];
    }
    if (paymentAccountStatusError || !this.reservationFee) {
      this.paymentRequired = false;
    }
    const json: any = {
      store: { id: this.store.id },
      quota: Number(this.quota),
      sectorId: this.sectorId,
      seats: this.seats,
      overbooking: this.overbooking,
      description: this.description,
      reservationDate: moment(this.reservationDate).format('YYYY-MM-DD'),
      reservationTime: this.reservationTime,
      reservationType: this.config.reservationType,
      customer: false,
      paymentType: paymentMethod,
      paymentRequired: this.paymentRequired,
      configType: this.configType,
    };
    if (this.user) {
      json.user = { id: this.user.id };
    } else if (this.customerInfo) {
      json.customerInfo = this.customerInfo;
      json.customerInfo.phone = UtilHelper.unmask(this.customerInfo.phone);
      if (this.customerInfo.cpf) {
        json.customerInfo.cpf = UtilHelper.unmask(this.customerInfo.cpf);
      }
    }
    if (this.customReservationFee && this.customReservationFee > 0) {
      json.reservationFee = this.customReservationFee;
    }
    return json;
  }

  toJsonUpdate(): any {
    const json: any = {
      id: this.id,
      store: { id: this.store.id },
      quota: Number(this.quota),
      sectorId: this.sectorId,
      seats: this.seats,
      overbooking: this.overbooking,
      description: this.description,
      reservationDate: moment(this.reservationDate).format('YYYY-MM-DD'),
      reservationTime: this.reservationTime,
      reservationType: this.config.reservationType,
      customer: false,
      configType: this.configType,
    };
    if (this.user) {
      json.user = { id: this.user.id };
    } else if (this.customerInfo) {
      json.customerInfo = this.customerInfo;
      json.customerInfo.phone = UtilHelper.unmask(this.customerInfo.phone);
      if (this.customerInfo.cpf) {
        json.customerInfo.cpf = UtilHelper.unmask(this.customerInfo.cpf);
      }
    }
    return json;
  }
}

export class Employee {
  id: number;
  name: string;
}

export interface ShortReservationReport {
  date: string;
  countDescription: string;
  hours: ShortReservationReportHours[];
}

export interface ShortReservationReportHours {
  hour: string;
  count: number;
  quota: number;
  shortReservations: ShortReservationReportItem[];
}

export interface ShortReservationReportItem {
  quota?: number; // PEOPLE
  seats?: number; // TABLE
  sectorId?: number;
  count: number;
  description: string;
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/models/reservation.model.ts